import React, { useEffect, useState } from "react";
import styles from "./curd.module.scss";
import {
  KoDivider,
  KoImage,
  KoLoader,
  KoTabs,
  KoText,
  KoTitle
} from "packages";
import CustomerStatus from "./customerStatus";
import KoIcon from "@kwapio/icons";
import CustomerOrder from "./customerOrder";
import CustomerTicket from "./customerTicket";

const CustomerDetails = () => {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, []);

  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <div className={styles.customerDetailsContainer}>
        {/* LEFT SIDE */}
        <div className={styles.leftContainer}>
          <div className={styles.customerProfile}>
            <div className={styles.profile}>
              <KoImage
                className={styles.profileImageBackground}
                alt="name"
                src="/images/bg.png"
                width={100}
                height={100}
                preview={false}
              />

              <KoImage
                className={styles.profileImage}
                alt="name"
                src="/images/AppTestingImage.jpg"
                width={100}
                height={100}
                preview={false}
              />

              <div className={styles.customerName}>
                <KoText className={styles.Text} text="Jayaprakash M" />
                <KoText className={styles.Text} text="Active" />
              </div>
              <KoDivider orientation="left" orientationMargin="0" />
            </div>
            <div className={styles.profileicons}>
              <KoIcon
                className={styles.emailIcons}
                name="EmailOutlined"
                height={16}
                width={16}
              />
              <KoIcon
                className={styles.phoneIcons}
                name="PhoneOutlined"
                color={"#707A8F"}
                height={16}
                width={16}
              />
              <div className={styles.message}>
                <KoIcon name="ChatOutlined" height={16} width={16} />
                <KoText className={styles.labelText} text="Message" />
              </div>
            </div>
          </div>

          <div className={styles.profileInfo}>
            <div className={styles.Title}>
              <KoTitle level={4} text={"Customer Details"} />
            </div>
            <div className={styles.viewMode}>
              <div className={styles.labelRow}>
                <KoIcon name="QrCodeOutlined" height={16} width={16} />
                <KoText className={styles.labelText} text="ID" />
              </div>
              <div className={styles.value}>
                <KoText className={styles.nameText} text="2930182" />
              </div>
            </div>

            <div className={styles.viewMode}>
              <div className={styles.labelRow}>
                <KoIcon name="EmailOutlined" height={16} width={16} />
                <KoText className={styles.labelText} text="Email" />
              </div>
              <div className={styles.value}>
                <KoText
                  className={styles.nameText}
                  text="jayaprakash@kwapio.com"
                />
              </div>
            </div>

            <div className={styles.viewMode}>
              <div className={styles.labelRow}>
                <KoIcon name="PhoneOutlined" height={16} width={16} color={'#707A8F'} />
                <KoText className={styles.labelText} text="Phone Number" />
              </div>
              <div className={styles.value}>
                <KoText className={styles.nameText} text="+91 9655436081" />
              </div>
            </div>

            <div className={styles.viewMode}>
              <div className={styles.labelRow}>
                <KoIcon name="LandMarkOutlined" height={16} width={16}  />
                <KoText className={styles.labelText} text="Shipping Address" />
              </div>
              <div className={styles.value}>
                <KoText
                  className={styles.nameText}
                  text="Prithivimangalam, Kallakurichi, Tamil Nadu, 606206"
                />
              </div>
            </div>

            <div className={styles.viewMode}>
              <div className={styles.labelRow}>
                <KoIcon name="OrderBasketOutlined" height={16} width={16} />
                <KoText className={styles.labelText} text="Last Transaction" />
              </div>
              <div className={styles.value}>
                <KoText
                  className={styles.nameText}
                  text="14 January 2023, 10.00"
                />
              </div>
            </div>

            <div className={styles.viewMode}>
              <div className={styles.labelRow}>
                <KoIcon name="OrderDateOutlined" height={16} width={16} />
                <KoText className={styles.labelText} text="Join" />
              </div>
              <div className={styles.value}>
                <KoText
                  className={styles.nameText}
                  text="14 January 2023, 10.00"
                />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className={styles.rightContainer}>
          <div className={styles.customerOrderStatus}>
            <CustomerStatus />
          </div>
          <div className={`${styles.wrapper} profileSection`}>
            <KoTabs
              className={styles.tabsection}
              options={[
                { label: "Order", key: "order", children: <CustomerOrder /> },
                { label: "Ticket", key: "ticket", children: <CustomerTicket /> }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
